import { ReactNode, useState } from "react";

interface ResponsiveGridProps<T> {
  items: T[];
  itemsPerRow?: number;
  maxRowsMobile?: number;
  maxRowsDesktop?: number;
  children: (item: T) => ReactNode;
}

const ResponsiveGrid = <T,>({
  items,
  itemsPerRow = 2,
  maxRowsMobile = 1,
  maxRowsDesktop = 3,
  children,
}: ResponsiveGridProps<T>) => {
  const [showAll, setShowAll] = useState(false);

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const rowsToShow = isMobile ? maxRowsMobile : maxRowsDesktop;
  const initialItemsToShow = itemsPerRow * rowsToShow;

  const needsShowMore = items.length > initialItemsToShow;
  const displayedItems = showAll ? items : items.slice(0, initialItemsToShow);

  return (
    <div className="mt-8">
      <div
        className={`grid grid-cols-${itemsPerRow} md:grid-cols-4 lg:grid-cols-6 gap-8`}
      >
        {displayedItems.map((item) => children(item))}
      </div>

      {needsShowMore && (
        <div className="mt-6 text-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="bg-white border border-black text-black px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 transition"
          >
            {showAll ? "Show Less" : `Show More (${items.length - initialItemsToShow} more)`}
          </button>
        </div>
      )}
    </div>
  );
};

export default ResponsiveGrid;